namespace $.$$ {
	$mol_style_define($bog_formigo_dashboard, {
		Body_content: {
			padding: $mol_gap.block,
		},
	})

	$mol_style_define($bog_formigo_dashboard_card, {
		padding: $mol_gap.block,
		margin: {
			bottom: '.5rem',
		},
		border: {
			radius: $mol_gap.round,
		},
		background: {
			color: $mol_theme.card,
		},
		cursor: 'pointer',

		Card_status: {
			font: {
				size: '.75rem',
			},
			opacity: 0.6,
		},
	})
}
